import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'User Management',
  attributeName: 'thirdPartyProviderUserManagement',
  visibleWhen: {
    field: 'thirdPartyType',
    value: 'ybvr_firebase',
  },
  fields: [
    {
      attributeName: 'terms_url',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Terms URL',
      placeholder: 'https://...',
    },
    {
      attributeName: 'terms_version',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Terms Version',
      placeholder: 'v1.0',
    },
    {
      attributeName: 'privacy_url',
      type: FormInputTypes.TEXT_INPUT.URL,
      label: 'Privacy URL',
      placeholder: 'https://...',
    },
    {
      attributeName: 'privacy_version',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Privacy Version',
      placeholder: 'v1.0',
    },
    {
      attributeName: 'user_management_favicon',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'User Management Favicon',
      fileType: ['.svg', '.png', '.ico'],
    },
    {
      attributeName: 'user_management_logo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'User Management Logo',
      fileType: ['.png', '.jpg', '.jpeg', '.svg'],
    },
    {
      attributeName: 'user_management_background',
      type: FormInputTypes.BACKGROUND,
      label: 'User Management Background',
      fileType: ['.png', '.jpg', '.jpeg'],
    },
    {
      attributeName: 'user_management_text_color',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text Color',
    },
    {
      attributeName: 'user_management_title_color',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Title Color',
    },
    {
      attributeName: 'user_management_subtitle_color',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Subtitle Color',
    },
  ],
};